
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  Input,
  Type,
  ViewChild,
  ViewContainerRef,
  OnDestroy,
  ChangeDetectionStrategy
} from '@angular/core';
import { GalaxyAbstractFilterChip, GalaxyFilterValueInterface } from './interface';

@Component({
  selector: 'glxy-custom-filter-chip',
  template: ` <ng-template #chipOverrideComponent /> `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class GalaxyCustomFilterChipComponent implements GalaxyAbstractFilterChip, AfterViewInit, OnDestroy {
  private componentRef: ComponentRef<GalaxyAbstractFilterChip> | null = null;

  @Input({ required: true }) filterChip!: Type<GalaxyAbstractFilterChip>;
  _initialValues: GalaxyFilterValueInterface[] = [];

  @Input() set initialValue(values: GalaxyFilterValueInterface[]) {
    this._initialValues = values;
  }

  @ViewChild('chipOverrideComponent', { static: false, read: ViewContainerRef }) overrideRef?: ViewContainerRef;

  constructor(private ref: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    if (!this.filterChip) {
      console.error('No override found for filter chip');
      return;
    }

    const viewContainerRef = this.overrideRef;
    if (!viewContainerRef) return;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent<GalaxyAbstractFilterChip>(this.filterChip);
    componentRef.instance.initialValue = this._initialValues;
    this.componentRef = componentRef;
    this.ref.detectChanges();
  }

  ngOnDestroy(): void {
    this.componentRef?.destroy();
    this.componentRef = null;
  }
}
